import { ApplicantType } from "shared/types";
import { ApplicantRoleLabel, toMoney } from "shared/utils";
import { ApplicationMetricData, GroupStatMetricNames } from "api/applications";

export const formatValueByType = (
  value: number | null = 0,
  metricType?: GroupStatMetricNames
) => {
  if (value === null) return "-";
  switch (metricType) {
    case GroupStatMetricNames.GrossIncome:
    case GroupStatMetricNames.NetIncome:
    case GroupStatMetricNames.SelfReportedGrossIncome:
      return toMoney(value);
    case GroupStatMetricNames.GrossIncomeToRentRatio:
    case GroupStatMetricNames.SelfReportedGrossIncomeToRent:
      return `${value.toFixed(2)}x`;
    case GroupStatMetricNames.DebtToGrossIncome:
    case GroupStatMetricNames.DebtToNetIncome:
    case GroupStatMetricNames.SelfReportedDebtToGrossIncome:
      return `${value.toFixed(2)}%`;
    case GroupStatMetricNames.AverageCreditScore:
    case GroupStatMetricNames.MinCreditScore:
    case GroupStatMetricNames.MaxCreditScore:
    case GroupStatMetricNames.NoCreditScorePeople:
    default:
      return value;
  }
};

export const collapseRoles = (selectedRoles?: ApplicantType[]) => {
  if (!selectedRoles || !selectedRoles.length || selectedRoles.length === 3)
    return "All roles";
  return selectedRoles
    .map((role) => `${ApplicantRoleLabel[role]}s`)
    .join(" & ");
};

/** Get applicant id for linking to credit report */
export const getRelevantApplicantId = (metricData: ApplicationMetricData) => {
  if (!metricData.applicants.length) return;

  if (metricData.metric === GroupStatMetricNames.MaxCreditScore)
    return metricData.applicants.reduce((highest, curr) =>
      highest.value > curr.value ? highest : curr
    ).applicant_id;

  if (metricData.metric === GroupStatMetricNames.MinCreditScore)
    return metricData.applicants.reduce((lowest, curr) =>
      lowest.value < curr.value ? lowest : curr
    ).applicant_id;

  return metricData.applicants[0].applicant_id;
};
